import { render, staticRenderFns } from "./ComparisonReportResultModal.vue?vue&type=template&id=68dd5c7c&scoped=true&"
import script from "./ComparisonReportResultModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ComparisonReportResultModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd5c7c",
  null
  
)

export default component.exports